import { Interweave } from "interweave";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GET_CONTENTS_BY_MENU_ID } from "../../constant/constants";
import ContactForm from "../ContactFrom";

function items(obj) {
  let content = [];

  // eslint-disable-next-line no-unused-vars
  for (let key in obj) {
    let contentItem = {};
    let objs = obj;

    contentItem[`${key}`] = objs[key];
    content.push(contentItem);
  }
  return content;
}
const Contactpage = (props) => {
  const { id } = useParams();
  const [contents, setContents] = useState("");
  const [contentEmail, setContentEmail] = useState({});
  const [contentAddress, setContentAddress] = useState({});
  const [contentCall, setContentCall] = useState({});
  const [contentMap, setContentMap] = useState({});

  console.log("menuID", contentMap);

  //for get menu
  useEffect(() => {
    fetch(`${GET_CONTENTS_BY_MENU_ID}/${id || props.id}`)
      .then((response) => response.json())
      .then((data) => {
        setContents(data.menu_contents);
        setContentEmail(
          data.menu_contents.find((info) => info.name === "Email Us")
        );
        setContentAddress(
          data.menu_contents.find((info) => info.name === "Address")
        );
        setContentCall(
          data.menu_contents.find((info) => info.name === "Call Now")
        );
        setContentMap(
          data.menu_contents.find((info) => info.name === "Map")
        );

        console.log("ContactContent", data);
      })
      .catch(() => {});
  }, [id, props.id]);

  //for content items
  const newContents = items(contents);
  console.log("content Contact", newContents);

  const value =
    '<p>https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.3432361199048!2d90.41122508885499!3d23.735136600000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b9e61fa751a3%3A0xc7a23dee35be9928!2sNayapaltan%20islam%20tower!5e0!3m2!1sen!2sbd!4v1736308260051!5m2!1sen!2sbd" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade</p>';
  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              <div className="row">
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12 office-info-item">
                  <div className="">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-placeholder"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                    {
                        contentAddress && (
                          <>
                            <h2>{contentAddress.name}</h2>
                            <Interweave
                              allowAttributes
                              allowElements
                              disableLineBreaks={true}
                              content={contentAddress.value}
                            />
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12 office-info-item">
                  <div className="">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-email"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      {
                        contentEmail && (
                          <>
                            <h2>{contentEmail.name}</h2>
                            <Interweave
                              allowAttributes
                              allowElements
                              disableLineBreaks={true}
                              content={contentEmail.value}
                            />
                          </>
                        )
                      }
                     
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12 office-info-item">
                  <div className="">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-phone-call"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                    {
                        contentCall && (
                          <>
                            <h2>{contentCall.name}</h2>
                            <Interweave
                              allowAttributes
                              allowElements
                              disableLineBreaks={true}
                              content={contentCall.value}
                            />
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpo-contact-title">
              <h2>Have Any Question?</h2>
              <p>
                It is a long established fact that a reader will be distracted
                content of a page when looking.
              </p>
            </div>
            <div className="wpo-contact-form-area" style={{ margin: "30px" }}>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <section className="wpo-contact-map-section">
        <div className="wpo-contact-map">
       

<div
        style={ {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'auto',
          width: '100%',
        } }
      >
        <iframe
          title="Map"
          src={ value.slice( 3, -4 ) }
          style={ {
            height: '500px',
            width: '100%',
            border: 'none',
          } }
        ></iframe>
      </div>
        </div>
      </section>
    </section>
  );
};

export default Contactpage;
